import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { jwtDecode } from 'jwt-decode'
import { firstValueFrom } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ManagedLoginService {
  constructor (private readonly httpClient: HttpClient) {}

  signIn () {
    window.location.href =
      `${environment.cognitoDomain}/login/continue` +
      `?client_id=${environment.cognito.userPoolWebClientId}` +
      `&redirect_uri=${this.getRedirectUri()}` +
      '&response_type=code' +
      '&scope=email openid phone profile'
  }
  signOut () {
    window.localStorage.clear()
    this.signIn()
  }

  getRedirectUri () {
    return environment.isLocal
      ? 'http://localhost:4200/callback'
      : environment.appEnv == 'prod'
      ? 'https://ayb.explorandes.app/callback'
      : 'https://dev-ayb.explorandes.app/callback'
  }

  getCognitoToken (code: string) {
    const clientId = environment.cognito.userPoolWebClientId
    const tokenUrl = `${environment.cognitoDomain}/oauth2/token`

    const body = new HttpParams()
      .set('grant_type', 'authorization_code')
      .set('client_id', clientId)
      .set('redirect_uri', this.getRedirectUri())
      .set('code', code)

    return this.httpClient.post(tokenUrl, body.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }

  async refreshToken () {
    const clientId = environment.cognito.userPoolWebClientId
    const tokenUrl = `${environment.cognitoDomain}/oauth2/token`
    const refreshToken = window.localStorage.getItem('refresh_token')

    if (!refreshToken) {
      console.error('No refresh token available, user must log in again')
      this.signOut()
      return
    }

    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('client_id', clientId)
      .set('refresh_token', refreshToken)

    try {
      // Usamos await para esperar que se complete la llamada HTTP antes de continuar
      const response: any = await firstValueFrom(
        this.httpClient.post(tokenUrl, body.toString(), {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      )

      console.log({
        response
      })
      // Si la respuesta es exitosa, guardamos los tokens
      window.localStorage.setItem('access_token', response.access_token)
      window.localStorage.setItem('id_token', response.id_token)

      // Llamamos a la función para programar la actualización del token
      this.scheduleTokenRefresh()
    } catch (error: any) {
      console.error('Error refreshing token:', error)
      if (error.status === 400) {
        console.warn('Refresh token expired, logging out user')
        this.signOut()
      }
    }
  }

  decodeToken () {
    const idToken = window.localStorage.getItem('id_token')
    if (!idToken) {
      return null
    }

    try {
      return jwtDecode<{
        'cognito:groups'?: string[]
        email?: string
        middle_name?: string
        family_name?: string
        sub?: string
        exp?: number
      }>(idToken)
    } catch (error) {
      console.error('Error al decodificar el token:', error)
      return null
    }
  }

  scheduleTokenRefresh () {
    const decoded = this.decodeToken()
    if (!decoded || !decoded.exp) {
      console.error('Token is invalid or does not have an expiration time')
      return
    }

    const fiveMinutes = 5 * 60 * 1000
    const expiresInMs = decoded.exp * 1000 - Date.now() - fiveMinutes

    setTimeout(() => {
      this.refreshToken()
    }, expiresInMs)
  }

  isTokenExpired () {
    const decoded = this.decodeToken()
    if (!decoded || !decoded.exp) {
      return true
    }
    return decoded.exp * 1000 < Date.now()
  }
}
